// extracted by mini-css-extract-plugin
module.exports = {"Card":"style_Card__A7vfL","Marck":"style_Marck__kDtLp","Wrapper":"style_Wrapper__j3RBa","Content":"style_Content__17AVH","Text":"style_Text__2ZtE2","Result":"style_Result__3U8k-"};